import React, { useState, useEffect, useMemo } from 'react';
import { Button, Dimensions, FlatList, Pressable, ScrollView, StyleSheet, TextInput, TouchableOpacity, View } from 'react-native'

import tw from '../../../../../../styles/tailwind';
import Text from '../../../../../../components/Text';
import Icon from '../../../../../../components/IcomoonIcon';
import Modal from '../../../../../../components/Modal';
import BottomSheet from '../../../../../../components/BottomSheet';
import { useForm } from 'react-hook-form';
import Input from '../../../../../../components/Forms/Input';
import Select from '../../../../../../components/Forms/Select';
import IconButton from '../../../../../../components/IconButton';




import api from '../../../../../../utils/api';
import { useQuery } from '@tanstack/react-query';
import useFormSubmit from '../../../../../../hooks/useFormSubmit';

import { PaymentMethodSelector, UnitAutocomplete } from '../AddPaymentModal';
import useActiveAdminCommunity from '../../../../../../hooks/useActiveAdminCommunity';





function EditableFeeRow({ title, subtitle, initialValue, onChange, onDeleteFee }){
  const [value, setValue] = useState(initialValue);

  function _onChange(text){
    setValue(text)
    onChange?.(text)
  }

  return (
    <View
      style={tw.style(`row bg-gray-100 rounded-xl px-4 py-2`)}
    >
      <View style={tw`flex-1`}>
        <Text style={tw`font-600`}>{title}</Text>
        <Text style={tw`text-gray-400`}>{subtitle}</Text>

        {/* <View style={tw`row`}>
                    <Text style={tw`text-red font-600`}>${unitFee.pending}</Text>
                    {
                      (unitFee.paid > 0) &&
                      <Text style={tw`text-gray-400 ml-2`}>(Abonados: ${unitFee.paid})</Text>
                    }
                  </View> */}
        {/* <Text>{JSON.stringify(fee)}</Text> */}
      </View>

      <View style={tw`row`}>
        <TextInput
          style={tw`pl-8 bg-white rounded text-gray-500 font-600 pr-3 py-1`}
          value={`${value}`}
          onChangeText={_onChange}
          keyboardType="numeric"
        />
        <Text style={tw`absolute left-2 top-2`}>$</Text>
      </View>

      <TouchableOpacity style={tw`-mr-2 px-1.5 py-1.5 ml-2`} onPress={onDeleteFee}>
        <Icon name='close' color={'#555'} size={15} />
      </TouchableOpacity>
    </View>
  )
}


function SelectNewPepepe({ communityId, onAddFee, onRequestClose }){
  const { control, watch } = useForm();
  const fee_id = watch('fee_id')

  const { isLoading, error, data: fees } = useQuery({
    queryKey: ['community.fees', communityId],
    queryFn: () => api.get(`/communities/${communityId}/fees`).then(response => response.data),
  })


  const options = useMemo(() => {
    const defaultValue = { value: "", label: "Sin definir" }

    const options = fees?.map(fee => {
      return { value: fee.uuid, label: fee.name }
    })

    return options ? [...options] : []
  }, [fees])


  const addFee = () => {
    onAddFee?.(fees.find(e => e.uuid == fee_id))
  }

  return (
    <Modal 
      style={{ modal: `w-90%` }}
      onRequestClose={onRequestClose}
    >
      <Text>Agregar adeudo</Text>
      
      <Select
        control={control}
        name={"fee_id"}
        placeholder={{ value: "", label: "Sin definir" }}
        items={options}
        // items={[]}
        rules={{}}
        style={{ wrapper: `mb-0`, input: tw`bg-gray-100` }}
      />


      <IconButton
        title={"Agregar"}
        disabled={!fee_id}
        onPress={addFee}
      />
    </Modal>
  )
}



export default function EditPaymentModal({ payment, onRequestClose, visible, onPaymentEdited }) {
  const unit = payment.unit

  const { control, reset, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      folio: payment.folio,
      payment_method_id: payment.payment_method?.uuid,
    }
  });
  const [errorMessage, setErrorMessage] = useState();
  const { communityId } = useActiveAdminCommunity()


  const [paymentFees, setPaymentFees] = useState({
    unit_fees: payment.fee_units,
    fees: [],
  });

  const [showAddNewFeeModal, setShowAddNewFeeModal] = useState(false);

  const totalAmount = useMemo(() => {
    let total = 0
    total = paymentFees.unit_fees.reduce((acc,b) => acc + parseFloat(b.amount), total)
    total = paymentFees.fees.reduce((acc,b) => acc + parseFloat(b.amount), total)
    return total
  }, [paymentFees])



  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: onPaymentEdited,
    onError: (error) => {
      if (error?.message) {
        setErrorMessage(error?.message)
      }
    },
    successToastMessage: "Pago guardado",
    endpoint: `/communities/${communityId}/fees/payments/${payment.uuid}`,
  })

  useEffect(() => {
    reset()
    setValue("unit_id", unit.uuid)
  }, []);




  const canSubmit = paymentFees.fees.length > 0 || paymentFees.unit_fees.length > 0


  const _submitForm = (data) => {
    const _data = {
      // ...payment,
      ...data,
    }


    data.apply_date = ""

    _data.unit_fees = paymentFees.unit_fees.map(e => {
      return { id: e.uuid, amount: e.amount }
    })

    _data.fees = paymentFees.fees.map(e => {
      return { id: e.uuid, amount: e.amount }
    })

    console.log("shazaaaa", _data)
    submitForm(_data)
  }

  const onUnitFeeChange = (unitFee, i, value) => {

    console.log(i, unitFee, value)
    const _unitFee = {...unitFee}
    _unitFee.amount = value

    const _paymentFees = {...paymentFees}
    _paymentFees.unit_fees[i] = _unitFee

    setPaymentFees(_paymentFees)
  }

  const onFeeChange = (fee, i, value) => {
    const _fee = {...fee}
    _fee.amount = value

    const _paymentFees = {...paymentFees}
    _paymentFees.fees[i] = _fee

    setPaymentFees(_paymentFees)
  }

  const addFee = (fee) => {
    setPaymentFees({
      ...paymentFees,
      fees: [
        ...paymentFees.fees,
        fee,
      ]
    })
  }

  const deleteFee = (feeIndex) => {
    const _paymentFees = { ...paymentFees }

    _paymentFees.fees.splice(feeIndex, 1)

    setPaymentFees(_paymentFees)
  }

  const deleteUnitFee = (index) => {
    const _paymentFees = { ...paymentFees }

    _paymentFees.unit_fees.splice(index, 1)

    setPaymentFees(_paymentFees)
  }





  const windowHeight = Dimensions.get('window').height;


  return (
    <BottomSheet onRequestClose={onRequestClose} visible={visible} height={windowHeight}>
      <View style={tw`flex-1 flex pt-6 pb-0 px-5 justify-between`}>
        <View style={tw`flex-1`}>
          {/* Info vivienda */}
          <View style={tw`mb-4 px-3`}>
            <Text style={tw`text-lg font-600 text-secondary`}>{unit.name}</Text>

            {
              (unit.owners?.length > 0) &&
              <Text style={tw`font-600 text-gray-500`}>{unit.owners[0].name}</Text>
            }

            <TouchableOpacity
              style={tw`absolute -top-0 right-2 items-center justify-center`}
              onPress={onRequestClose}
            >
              <Icon name='close' style={tw`text-red`} size={26} />
            </TouchableOpacity>
          </View>


          {/* 
            Lista de adeudos
          */}
          <View style={tw`flex-1`}>
            <Text style={tw`text-gray-500 mb-4`}>Adeudos a pagar</Text>

            <ScrollView>
              <View style={tw`gap-y-3`}>
                {
                  paymentFees.unit_fees?.map((unitFee, i) => {

                    return (
                      <EditableFeeRow
                        key={unitFee.uuid}
                        title={unitFee.fee.name}
                        subtitle={unitFee.fee.type?.name}
                        initialValue={unitFee.paid}
                        onChange={value => onUnitFeeChange(unitFee, i, value)}
                        onDeleteFee={() => deleteUnitFee(i)}
                      />
                    )
                  })
                }
                {
                  paymentFees.fees?.map((fee, i) => {

                    return (
                      <EditableFeeRow
                        key={fee.uuid}
                        title={fee.name}
                        subtitle={fee.type?.name}
                        initialValue={fee.amount}
                        onChange={value => onFeeChange(fee, i, value)}
                        onDeleteFee={() => deleteFee(i)}
                      />
                    )
                  })
                }
              </View>

              <IconButton
                title={'Agregar adeudo'}
                onPress={() => setShowAddNewFeeModal(true)}
                color='[#bbb]'
                style={tw`mt-8`}
              />
            </ScrollView>
          </View>
        </View>


        {/* Parte inferior */}
        <View style={tw``}>

          {/* $___ / $900 */}
          <View style={tw``}>

            <View style={tw`row justify-center py-6 items-start border-t border-b border-gray-100`}>
              <View style={tw`items-center`}>
                <Text style={tw`text-8 font-600  mt-1`}>${totalAmount}</Text>

                <Text style={tw`text-gray-300 text-xs -mt-1.5`}>Total a pagar</Text>
              </View>
            </View>
          </View>


          {/*
            Forma de pago
          */}
          <View style={tw`mb-2 py-6 row justify-between`}>
            <Text style={tw`text-gray-500`}>Forma de Pago</Text>

            <View style={tw`w-40`}>
              <PaymentMethodSelector control={control} name={"payment_method_id"} communityId={communityId} />
            </View>
          </View>


          <View style={tw`mb-2 pb-6 row justify-between`}>
            <Text style={tw`text-gray-500`}>Folio (opcional)</Text>

            <View style={tw`w-40`}>
              <Input
                control={control}
                name='folio'
                placeholder=''
                style={{
                  input: `w-full bg-gray-100 rounded-full px-3 py-1 text-primary`,
                  subcontainer: ` bg-transparent rounded-0`,
                  container: tw`mb-0`,
                }}
                editable={!payment.folio}
              // keyboardType="numeric"
              // rules={{ required: true }}
              />
            </View>
          </View>


          {
            errorMessage &&
            <Text style={tw`text-red text-center pb-6`}>{errorMessage}</Text>
          }



          <View style={tw` -mx-5`}>
            <IconButton
              title={isSubmitting ? "Guardando pago..." : "Guardar pago"}
              disabled={!canSubmit || isSubmitting}
              style={tw.style(`w-full rounded-b-0 rounded-t-3xl py-3`, (!canSubmit || isSubmitting) && `bg-gray-700`)}
              onPress={handleSubmit(_submitForm)}
            />
          </View>
        </View>
      </View>

      {
        showAddNewFeeModal &&
          <SelectNewPepepe
            communityId={communityId}
            onAddFee={fee => {
              addFee(fee)
              setShowAddNewFeeModal(false)
            }}
            onRequestClose={() => setShowAddNewFeeModal(false)}
          />
      }
    </BottomSheet>
  )
}